import { useState, useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import NavBar from "../NavBar";
import SponsorsContact from "./SponsorsContact";
import background1 from "../../images/background_sponsors.webp";
import Footer from "../Footer";

/* Platinum */
import Catana from '../../images/sponsors/1 - platinum/catana.png';
import GrupoPR from '../../images/sponsors/1 - platinum/grupo-pr.png';
import Mystic from '../../images/sponsors/1 - platinum/mystic.png';
import Palbit from '../../images/sponsors/1 - platinum/palbit.svg';

/* Gold */
import Coficab from '../../images/sponsors/2 - gold/coficab.png';
import Einhell from '../../images/sponsors/2 - gold/einhell.png';
import Elio from '../../images/sponsors/2 - gold/elio.png';
import Lotactree from '../../images/sponsors/2 - gold/lotactree.avif';
import Maximoferta from '../../images/sponsors/2 - gold/maximoferta.png';
import Movella from '../../images/sponsors/2 - gold/movella.png';
import Quantal from '../../images/sponsors/2 - gold/quantal.avif';

/* Silver */
import DCTech from '../../images/sponsors/3 - silver/4dc-tech.png';
import CINFU from '../../images/sponsors/3 - silver/CINFU.png';
import CODI from '../../images/sponsors/3 - silver/codi.png';
import EpsilonComposites from '../../images/sponsors/3 - silver/epsilon.png';
import Invacare from '../../images/sponsors/3 - silver/invacare.png';
import Kvaser from '../../images/sponsors/3 - silver/kvaser.png';
import Mauser from '../../images/sponsors/3 - silver/mauser.png';
import SolarShop from '../../images/sponsors/3 - silver/solarshop.png';
import Wurth from '../../images/sponsors/3 - silver/wurth.webp';

/* Bronze */
import AMoreira from '../../images/sponsors/4 - bronze/amoreira.png';
import Anodfarbe from '../../images/sponsors/4 - bronze/anodfarbe.png'; 
import Ceiia from '../../images/sponsors/4 - bronze/ceiia.png';
import Cladlaser from '../../images/sponsors/4 - bronze/cladlaser.png';
import EDMTech from '../../images/sponsors/4 - bronze/edmtech.jpg';
import Eurocircuits from '../../images/sponsors/4 - bronze/eurocircuits.png';
import Everythink from '../../images/sponsors/4 - bronze/everythink.png';
import KitPinte from '../../images/sponsors/4 - bronze/kitpinte.webp';
import Polipop from '../../images/sponsors/4 - bronze/polipop.png';
import SGFoam from '../../images/sponsors/4 - bronze/sgfoam.png'; 

/* General */
import Bcomp from '../../images/sponsors/5 - general/bcomp.png';
import CFPIMM from '../../images/sponsors/5 - general/cfpimm.png';
import Chuvitex from '../../images/sponsors/5 - general/chuvitex.png';
import DontWorry from '../../images/sponsors/5 - general/dont-worry-douro.png';
import EasyComposites from '../../images/sponsors/5 - general/easy-composites.png';
import EasyEDA from '../../images/sponsors/5 - general/easyEDA.png';
import Igus from '../../images/sponsors/5 - general/igus.png';
import Inegi from '../../images/sponsors/5 - general/inegi.png';
import Invicta3D from '../../images/sponsors/5 - general/invicta3d.png';
import JLCPCB from '../../images/sponsors/5 - general/jlcpcb.png';
import LojaFerragens from '../../images/sponsors/5 - general/lojaFerragens.png';
import Molex from '../../images/sponsors/5 - general/molex.avif';
import Mouser from '../../images/sponsors/5 - general/mouser.webp';
import Olika from '../../images/sponsors/5 - general/olika.png';
import Rebelco from '../../images/sponsors/5 - general//rebelco.png';
import SaintGobain from '../../images/sponsors/5 - general/saint-gobain.jpg';
import TracoPower from '../../images/sponsors/5 - general//traco-power.jpg';

/* Software */
import Altium from '../../images/sponsors/6 - software//altium.png';
import Cadflow from '../../images/sponsors/6 - software/cadflow.png';
import Inductiva from '../../images/sponsors/6 - software/inductiva.png';
import Orca3D from '../../images/sponsors/6 - software/orca-3d.webp';
import RapidHarness from '../../images/sponsors/6 - software/rapid-harness.png';

/* Institutional */
import AEFEUP from '../../images/sponsors/7 - institutional/aefeup.png';
import CVVC from '../../images/sponsors/7 - institutional/cvvc.jpg';
import DeMec from '../../images/sponsors/7 - institutional/demec.png';
import FADEUP from '../../images/sponsors/7 - institutional/FADEUP.webp';
import FAJDP from '../../images/sponsors/7 - institutional/fajdp.png';
import Feup from '../../images/sponsors/7 - institutional/feup.png';
import IPDJ from '../../images/sponsors/7 - institutional/ipdj.png';
import Neem from '../../images/sponsors/7 - institutional/neem.svg';
import JuniFeup from '../../images/sponsors/7 - institutional/JuniFEUP.png';
import YCP from '../../images/sponsors/7 - institutional/ycp.jpg';

/* Partners */
import Cadence from '../../images/sponsors/8 - partners/cadence.webp';
import Elergone from '../../images/sponsors/8 - partners/elergone.svg';
import Navicork from '../../images/sponsors/8 - partners/navicork.png';
import NKT from '../../images/sponsors/8 - partners/nkt.png';
import Ultraflex from '../../images/sponsors/8 - partners/ultraflex.png';

gsap.registerPlugin(ScrollTrigger);

const tiers = [
  { name: "Platinum", color: "#8C5A5A" },
  { name: "Gold", color: "#C3B67E" },
  { name: "Silver", color: "#8D8B8B" },
  { name: "Bronze", color: "#A2917E" },
  { name: "General", color: "#62727D" },
  { name: "Software", color: "#74C365" },
  { name: "Institutional", color: "#6B7280" },
  { name: "Partners", color: "#2f597c" },
];

const sponsors = {
  Platinum: [
    { name: "Catana", link: 'https://www.catanagroup.com/en/', logo: Catana },
    { name: "Grupo PR", link: 'https://www.prgrupo.com/pt/', logo: GrupoPR },
    { name: "Mystic Invest", link: 'https://www.mysticinvest.com/', logo: Mystic},
    { name: "Palbit", link: 'https://www.palbit.pt/pt', logo: Palbit }
  ],
  Gold: [
    { name: "Coficab", link: 'https://www.coficab.com/', logo: Coficab},
    { name: "Einhell", link: 'https://www.einhell.pt/', logo: Einhell},
    { name: "Elio Kayaks", link: 'http://www.eliokayaks.com/', logo: Elio},
    { name: "Lotactree", link: 'https://www.lotactree.com/', logo: Lotactree},
    { name: "Maximoferta", link: 'https://www.maximoferta.com/pt/', logo: Maximoferta},
    { name: "Movella", link: 'https://www.xsens.com/movella', logo: Movella},
    { name: "Quantal", link: 'https://www.quantal.pt/', logo: Quantal}
  ],
  Silver: [
    { name: "4DC Tech", link: "#", logo: DCTech },
    { name: "CINFU", link: "https://cinfu.pt/", logo: CINFU },
    { name: "CODI", link: "https://www.codi.pt/", logo: CODI },
    { name: "Epsilon Composites", link: "https://www.epsiloncomposites.com/", logo: EpsilonComposites },
    { name: "Invacare", link: 'https://www.invacare.pt/pt', logo: Invacare },
    { name: "Kvaser", link: "https://kvaser.com/", logo: Kvaser },
    { name: "Mauser.pt", link: "https://www.mauser.pt/", logo: Mauser },
    { name: "SolarShop", link: "https://www.solarshop.pt/pt", logo: SolarShop },
    { name: "Würth", link: 'https://eshop.wurth.pt/', logo: Wurth },
  ],
  Bronze: [
    { name: "A Moreira", link: "https://www.a-moreira.pt/", logo: AMoreira },
    { name: "Anodfarbe", link: "https://edmtech.pt/", logo: Anodfarbe },
    { name: "Ceiia", link: "https://www.ceiia.com/", logo: Ceiia },
    { name: "Cladlaser", link: "https://cladlaser.com/", logo: Cladlaser },
    { name: "EDM Tech", link: "https://everythink.com/", logo: EDMTech },
    { name: "Eurocircuits", link: "https://www.eurocircuits.com/", logo: Eurocircuits },
    { name: "Everythink", link: "https://everythink.com/", logo: Everythink },
    { name: "KitPinte", link: "https://kitpinte.pt/", logo: KitPinte },
    { name: "Polipop", link: "https://polipop.pt/", logo: Polipop },
    { name: "SGFoam", link: "https://sgfoam.pt/", logo: SGFoam },
  ],
  General: [
    { name: "Bcomp", link: "https://bcomp.ch/", logo: Bcomp },
    { name: "CFPIMM", link: "https://www.cfpimm.pt/", logo: CFPIMM },
    { name: "Chuvitex", link: "https://www.chuvitex.com/", logo: Chuvitex },
    { name: "Don't Worry Douro", link: "https://dontworrydouro.com/", logo: DontWorry },
    { name: "Easy Composites", link: "https://www.easycomposites.eu/", logo: EasyComposites },
    { name: "Easy EDA", link: "https://easyeda.com/education", logo: EasyEDA },
    { name: "Igus", link: "https://www.igus.pt/", logo: Igus },
    { name: "Inegi", link: 'https://www.inegi.pt/pt/?', logo: Inegi },
    { name: "Invicta3D", link: "https://invicta3d.pt/", logo: Invicta3D },
    { name: "JLCPCB", link: "https://jlcpcb.com/", logo: JLCPCB },
    { name: "Loja das Ferragens", link: "https://lojadasferragens.pt/", logo: LojaFerragens },
    { name: "Molex", link: "https://www.molex.com/", logo: Molex },
    { name: "Mouser Eletronics", link: "https://pt.mouser.com/", logo: Mouser },
    { name: "Olika3D", link: "https://www.olika.de/", logo: Olika },
    { name: "Rebelco", link: "https://rebelco.pt/", logo: Rebelco },
    { name: "Saint-Gobain", link: "https://www.saint-gobain.com/", logo: SaintGobain },
    { name: "Traco Power", link: "https://www.tracopower.com/", logo: TracoPower },
  ],
  Software: [
    { name: "Altium", link: "https://www.altium.com/", logo: Altium },
    { name: "Cadflow", link: "https://www.cadflow.pt/", logo: Cadflow }, 
    { name: "Inductiva", link: "https://inductiva.ai/", logo: Inductiva },
    { name: "Orca3D", link: "https://orca3d.com/", logo: Orca3D },
    { name: "Rapid Harness", link: "https://rapidharness.com/", logo: RapidHarness },
  ],
  Institutional: [
    { name: "AEFEUP", link: 'https://aefeup.pt/', logo: AEFEUP},
    { name: "CVVC", link: 'https://www.facebook.com/cvvc.vianacastelo/', logo: CVVC},
    { name: "DEMEC", link: 'https://sigarra.up.pt/feup/en/uni_geral.unidade_view?pv_unidade=4', logo: DeMec },
    { name: "FADEUP", link: 'https://www.up.pt/fadeup/pt/', logo: FADEUP },
    { name: "FAJDP", link: 'https://fajdp.pt/', logo: FAJDP },
    { name: "FEUP", link: 'https://www.feup.pt/', logo: Feup },
    { name: "IPDJ", link: 'https://ipdj.gov.pt/', logo: IPDJ },
    { name: "NEEM", link: 'https://www.neemfeup.pt/', logo: Neem },
    { name: "JuniFEUP", link: 'https://www.junifeup.pt/', logo: JuniFeup },
    { name: "Yate Clube do Porto", link: 'https://ycporto.pt/', logo: YCP },
  ],
  Partners: [
    { name: "Cadence", link: "https://www.cadence.com/", logo: Cadence },
    { name: "Elergone Energia", link: "https://elergone.pt/", logo: Elergone },
    { name: "Navicork", link: "https://navicork.com/", logo: Navicork },
    { name: "NKT", link: "https://www.nkt.com/", logo: NKT },
    { name: "Ultraflex", link: "https://ultraflexgroup.it/", logo: Ultraflex },
  ]
};

const totalSponsors = Object.values(sponsors).reduce((sum, list) => sum + list.length, 0);

function SponsorCard({ sponsor, tierColor }) {
  const cardRef = useRef(null);

  useEffect(() => {
    if (cardRef.current) {
      gsap.fromTo(cardRef.current, {
        y: 20,
        opacity: 0,
        scale: 0.95,
      }, {
        scrollTrigger: {
          trigger: cardRef.current,
          start: 'top 90%',
          toggleActions: 'play none none reverse',
        },
        y: 0,
        opacity: 1,
        scale: 1,
        duration: 0.4,
        ease: 'power2.out',
      });
    }
  }, []);

  return (
    <a
      ref={cardRef}
      href={sponsor.link}
      target="_blank"
      rel="noreferrer"
      className="group relative bg-white rounded-xl border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
      style={{ aspectRatio: '5/4' }}
    >
      <div 
        className="absolute bottom-0 left-0 right-0 h-0.5 transition-transform duration-300 scale-x-0 group-hover:scale-x-100"
        style={{ backgroundColor: tierColor }}
      />
      <div className="relative z-10 flex items-center justify-center h-full p-3 md:p-4 lg:p-6">
        <img
          src={sponsor.logo}
          alt={sponsor.name}
          className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
        />
      </div>
    </a>
  );
}

function TierSection({ tier, sponsorList }) {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(titleRef.current, {
        x: -30,
        opacity: 0,
      }, {
        scrollTrigger: {
          trigger: titleRef.current,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
        x: 0,
        opacity: 1,
        duration: 0.5,
        ease: 'power2.out',
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={sectionRef} id={`tier-${tier.name}`} className="relative py-6 md:py-14">
      <div ref={titleRef} className="flex items-center gap-2 md:gap-4 mb-5 md:mb-8 px-4 md:px-8 max-w-6xl mx-auto">
        <div
          className="hidden md:block w-1 h-7 md:w-1.5 md:h-10 rounded-full"
          style={{ backgroundColor: tier.color }}
        />
        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold text-gray-900 font-custom">{tier.name}</h2>
        <div className="hidden md:block flex-1 h-px bg-gray-200" />
        <span className="hidden md:inline text-gray-400 text-xs md:text-sm font-custom">{sponsorList.length}</span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6 px-4 md:px-8 max-w-6xl mx-auto">
        {sponsorList.map((sponsor, idx) => (
          <SponsorCard key={idx} sponsor={sponsor} tierColor={tier.color} />
        ))}
      </div>
    </div>
  );
}

const SponsorsPage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showSideNav, setShowSideNav] = useState(false);
  const [activeTier, setActiveTier] = useState("");
  const heroRef = useRef(null);
  const tiersContainerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  }, [location]);

  useEffect(() => {
    if (heroRef.current) {
      gsap.fromTo(heroRef.current.querySelector('.hero-content'), {
        y: 40,
        opacity: 0,
      }, {
        y: 0,
        opacity: 1,
        duration: 0.8,
        delay: 0.2,
        ease: 'power3.out',
      });
    }

    const handleScroll = () => {
      setScrolled(window.scrollY > window.innerHeight * 0.3);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!tiersContainerRef.current) return;

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setShowSideNav(entry.isIntersecting);
    }, { threshold: 0.1 });

    observer.observe(tiersContainerRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveTier(entry.target.id.replace('tier-', ''));
        }
      });
    }, { threshold: 0.3 });

    tiers.forEach((tier) => {
      const el = document.getElementById(`tier-${tier.name}`);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const scrollToTier = (e, tierName) => {
    e.preventDefault();
    const el = document.getElementById(`tier-${tierName}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="relative min-h-screen bg-white">
      <NavBar activeSection="sponsors" />

      <div
        ref={heroRef}
        className="relative w-full h-screen bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: `linear-gradient(to bottom, rgba(15, 23, 42, 0.5), rgba(15, 23, 42, 0.85)), url(${background1})` }}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-mainBlue/10 rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-mainYellow/5 rounded-full blur-3xl" />
        </div>

        <div className="hero-content relative z-10 text-center px-4 max-w-4xl mx-auto">
          <h1 className="font-custom font-bold text-4xl sm:text-5xl md:text-7xl lg:text-8xl text-white leading-tight md:leading-none mb-4 md:mb-6">
            Meet our Sponsors
          </h1>
          <p className="text-gray-400 text-base sm:text-lg md:text-xl mx-auto font-custom px-2">
            Thank you to the companies and institutions that make our mission possible!
          </p>
          <div className="mt-8 md:mt-10 flex items-center justify-center gap-6 md:gap-8">
            <div className="text-center">
              <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-white font-custom">{totalSponsors}</p>
              <p className="text-gray-500 text-[10px] sm:text-xs uppercase tracking-wider mt-1 font-custom">Sponsors</p>
            </div>
            <div className="w-px h-10 md:h-12 bg-white/20" />
            <div className="text-center">
              <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-white font-custom">{tiers.length}</p>
              <p className="text-gray-500 text-[10px] sm:text-xs uppercase tracking-wider mt-1 font-custom">Levels</p>
            </div>
          </div>
        </div>

      </div>

      <div ref={tiersContainerRef} className="relative">
        {/* Desktop Side Nav */}
        <nav className={`hidden lg:block fixed right-6 top-1/2 -translate-y-1/2 z-30 transition-all duration-500 ${showSideNav ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8 pointer-events-none'}`}>
          <div className="flex flex-col gap-3 items-end">
            {tiers.map((tier) => (
              <a
                key={tier.name}
                href={`#tier-${tier.name}`}
                onClick={(e) => scrollToTier(e, tier.name)}
                className="group flex items-center gap-2 transition-all duration-300 hover:gap-3"
              >
                <span className={`text-xs font-custom transition-opacity duration-300 ${activeTier === tier.name ? 'opacity-100 text-gray-700' : 'opacity-0 group-hover:opacity-100 text-gray-400'}`}>{tier.name}</span>
                <div
                  className={`rounded-full transition-all duration-300 ${activeTier === tier.name ? 'w-3 h-3' : 'w-2 h-2 group-hover:w-3 group-hover:h-3'}`}
                  style={{ backgroundColor: tier.color, opacity: activeTier === tier.name ? 1 : 0.5 }}
                />
              </a>
            ))}
          </div>
        </nav>

        {tiers.map((tier) => (
          <TierSection
            key={tier.name}
            tier={tier}
            sponsorList={sponsors[tier.name]}
          />
        ))}
      </div>

      <SponsorsContact />
      <Footer />

    </div>
  );
};

export default SponsorsPage;
